module.exports = __webpack_public_path__ + "static/media/city.9dbd3cb9.png";